var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['flex flex-col cursor-pointer mx-1 no-drag no-highlight-color', 'pointer-events-none'],attrs:{"data-testid":`surfacePostPollChoiceButton${_setup.index + 1}`}},[_c('div',{class:[
      'flex items-center py-2',
      _setup.isDisplayModeSlideshow ? 'rounded-2xl' : 'rounded-xl',
      {
        'ps-7.5': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2.5,
        'ps-6': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2,
        'ps-3': (!_setup.isDisplayModeSlideshow && _setup.isStream) || (_setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 1),
        'ps-2': !_setup.isDisplayModeSlideshow && !_setup.isStream,
      },
      _setup.interactionsDisabled === _setup.SurfacePostPollChoiceInteractionsDisabled.None && {
        [_setup.pollColors.pollChoiceHoverBackground.light]: _setup.darkMode === false,
        [_setup.pollColors.pollChoiceHoverBackground.dark]: _setup.darkMode === true,
        [_setup.pollColors.pollChoiceHoverBackground.auto]: _setup.darkMode === 'auto',
      },
      _setup.interactionsDisabled === _setup.SurfacePostPollChoiceInteractionsDisabled.None && 'focus-visible:ring-2 active:ring-2',
      _setup.interactionsDisabled === _setup.SurfacePostPollChoiceInteractionsDisabled.None && {
        'active:ring-grape-500 focus-visible:ring-grape-500': _setup.darkMode === false,
        'active:ring-canary-500 focus-visible:ring-canary-500': _setup.darkMode === true,
        'active:ring-grape-500 dark:active:ring-canary-500 focus-visible:ring-grape-500 dark:focus-visible:ring-canary-500':
          _setup.darkMode === 'auto',
      },
      _setup.index === _setup.numChoices - 1 && 'mb-1',
    ],attrs:{"tabindex":_setup.interactionsDisabled === _setup.SurfacePostPollChoiceInteractionsDisabled.None ? 0 : -1,"aria-checked":_setup.selected}},[_c(_setup.OzIconButton,{class:[
        _setup.interactionsDisabled === _setup.SurfacePostPollChoiceInteractionsDisabled.None
          ? 'cursor-pointer pointer-events-auto'
          : 'pointer-events-none',
        _setup.selected
          ? {
              'text-grape-500': _setup.darkMode === false,
              'text-canary-500': _setup.darkMode === true,
              'text-grape-500 dark:text-canary-500': _setup.darkMode === 'auto',
            }
          : {
              'text-dark-text-200': _setup.darkMode === false,
              'text-light-text-200': _setup.darkMode === true,
              'text-dark-text-200 dark:text-light-text-200': _setup.darkMode === 'auto',
            },
        'shrink-0',
        '!bg-transparent',
        'pt-3',
        'pb-3',
        '-mt-3',
        '-mb-3',
      ],attrs:{"label":_vm.__('Select %{choiceText}', { choiceText: _setup.choiceText }),"icon-name":_setup.selected ? 'radio_selected' : 'radio_unselected',"icon-size":_setup.isDisplayModeSlideshow ? Math.max(20, 10 * _setup.pollScaleMultiplier) : 16,"size-preset":_setup.OzIconButtonSizePreset.Bare,"color-scheme":null,"dark-mode":_setup.darkMode},on:{"click":function($event){$event.stopPropagation();return _setup.onSelect.apply(null, arguments)},"pointerdown":function($event){$event.stopPropagation();},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _setup.onSelect.apply(null, arguments)}}}),_vm._v(" "),_c('p',{class:[
        'ps-3 break-word-anywhere',
        {
          'pe-7.5': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2.5,
          'pe-6': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2,
          'pe-3': !_setup.isDisplayModeSlideshow || (_setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 1),
        },
        _setup.isDisplayModeExpandedOrSlideshow || _setup.isStream ? 'text-body' : 'text-body-small',
        {
          'text-dark-text-100': _setup.darkMode === false,
          'text-light-text-100': _setup.darkMode === true,
          'text-dark-text-100 dark:text-light-text-100': _setup.darkMode === 'auto',
        },
        _setup.selected && 'font-semibold',
      ],attrs:{"data-testid":`surfacePostPollChoiceText${_setup.index + 1}`}},[_vm._v("\n      "+_vm._s(_setup.choiceText)+"\n    ")])],1),_vm._v(" "),(_setup.index !== _setup.numChoices - 1)?_c(_setup.OzDivider,{class:[
      'my-1',
      {
        'ms-16': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2.5,
        'ms-13': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 2,
        'ms-10': _setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 1,
        'ms-9': !_setup.isDisplayModeSlideshow || (_setup.isDisplayModeSlideshow && _setup.pollScaleMultiplier === 1),
      },
      {
        'me-8': _setup.isDisplayModeSlideshow && (_setup.pollScaleMultiplier === 2.5 || _setup.pollScaleMultiplier === 2),
        'me-4': _setup.isDisplayModeExpandedOrSlideshow,
        'me-3': !_setup.isDisplayModeExpandedOrSlideshow && _setup.isStream,
        'me-1': !_setup.isDisplayModeExpandedOrSlideshow && !_setup.isStream,
      },
    ],attrs:{"color-scheme":_setup.OzDividerColorScheme.Solid,"dark-mode":_setup.darkMode}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }